import { TableV2 } from '@anytag/shared-atoms';
import { YoutubeAnalyticsPostsPayload } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerYoutubeAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerYoutubeSponsoredPostsListTable } from './hooks';

export interface InfluencerYoutubeSponsoredPostsListProps extends TableData<YoutubeAnalyticsPostsPayload> {
  mainSocialAccountId?: number;
}

export const InfluencerYoutubeSponsoredPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: InfluencerYoutubeSponsoredPostsListProps) => {
  const { columns } = useInfluencerYoutubeSponsoredPostsListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="57px" noTopBorderRadius hasBorder />

      <InfluencerYoutubeAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
      />
    </>
  );
};
